import {
  Link as MuiLink,
  makeStyles,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Column, ColorDynamic, Columns, Stack } from '@superdispatch/ui';
import { Box } from '@superdispatch/ui-lab';
import { MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { ClickAwayListener } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import styled from 'styled-components';

interface PermissionTooltipProps {
  children: React.ReactNode;
}

const Link = styled(MuiLink)`
  color: ${ColorDynamic.Blue200};
  &:hover {
    cursor: pointer;
  }
`;

const useStyles = makeStyles(() => ({ tooltip: { maxWidth: '600px' } }));

export function PermissionTooltip({ children }: PermissionTooltipProps) {
  const { data: settings } = useCarrierSettings();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const { tooltip } = useStyles();

  const handleOpen = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen(true);
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpen(false);
      }}
    >
      <Box>
        <Tooltip
          arrow={true}
          open={open}
          interactive={true}
          classes={{ tooltip }}
          onClose={() => {
            setOpen(false);
          }}
          title={
            <Columns align="top" space="xsmall">
              <Column width="content">
                <Lock />
              </Column>
              <Column width="fluid">
                <Box width="325px">
                  <Stack space="small">
                    <Typography>
                      Your account isn&apos;t set up with the correct role(s) to
                      perform this action.
                    </Typography>
                    <Typography>
                      To gain access, ask{' '}
                      {settings?.account_admin?.email && (
                        <>
                          account Admin at{' '}
                          <Link
                            color="primary"
                            href={`mailto:${settings.account_admin.email}`}
                          >
                            {settings.account_admin.email}
                          </Link>{' '}
                          or
                        </>
                      )}{' '}
                      a{' '}
                      <Link
                        color="primary"
                        onClick={() => {
                          navigate({
                            pathname: '/users',
                            search: 'role=operations',
                          });
                        }}
                      >
                        user with Operations role
                      </Link>{' '}
                      to update your roles.
                    </Typography>
                  </Stack>
                </Box>
              </Column>
            </Columns>
          }
        >
          <div
            onMouseEnter={() => {
              setOpen(true);
            }}
            onClick={handleOpen}
            onClickCapture={handleOpen}
          >
            {children}
          </div>
        </Tooltip>
      </Box>
    </ClickAwayListener>
  );
}
